import { render, staticRenderFns } from "./safetyStatisticsCard.vue?vue&type=template&id=40b22fca&scoped=true&"
import script from "./safetyStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./safetyStatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./safetyStatisticsCard.vue?vue&type=style&index=0&id=40b22fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b22fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VOverlay,VProgressCircular,VRow})
